import { define, html } from "hybrids";

export interface VBroadcastPlaceholder {
  icon: string;
}

export default define<VBroadcastPlaceholder>({
  tag: "v-broadcast-placeholder",
  icon: "",
  render: ({ icon }) => html`
    <v-ui-icon name="${icon}" color="text-secondary"></v-ui-icon>
    <v-ui-text color="text-secondary" ygutter="1"><slot></slot></v-ui-text>
  `.css`
    :host {
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: center;
      flex: 1;
      height: 100%;
      padding: calc(var(--v-broadcast-layout-spacing) * 2);
    }

    v-ui-icon {
      --v-ui-icon-width: 100px;
      --v-ui-icon-height: 100px;
    }
  `,
});
